import * as React from "react";
import { formatCurrency, formatNumber } from "lib/globalize-util";
import { ICurrency } from "../../../product-collection-views/product-collection-grid-view/grid-renderers/pinned-row-renderers";

type CartValueProps = {
    label: string;
    value: number;
    strong?: boolean;
    isCurrency?: boolean;
    currency?: ICurrency;
    isPercentage?: boolean;
    dataTest: string;
};

export const formatPercentageOrCurrency = (value, isCurrency, currency, isPercentage) => {
    let formattedValue;
    if (value === undefined) {
        formattedValue = "-";
    } else if (isCurrency) {
        try {
            if (currency?.currency_code === "") {
                // when provide empty code, format value only.
                formattedValue = formatNumber(value, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            } else {
                // 3-letter currency code as defined by ISO 4217, eg. USD,EUR,CNY,GBP.
                formattedValue = formatCurrency(value, currency?.currency_code || "USD");
            }
        } catch (e) {
            formattedValue = value.toString();
        }
    } else if (isPercentage) {
        try {
            formattedValue = `${value.toFixed(2)} %`;
        } catch (e) {
            formattedValue = value.toString();
        }
    } else {
        try {
            formattedValue = formatNumber(value);
        } catch (e) {
            formattedValue = value.toString();
        }
    }
    return formattedValue;
};

export const CartValue = ({ label, value, strong, isCurrency, currency, isPercentage, dataTest }: CartValueProps) => {
    const formattedValue = formatPercentageOrCurrency(value, isCurrency, currency, isPercentage);
    return (
        <dl data-test={dataTest} data-value={value} className={strong ? "strongCart" : undefined}>
            <dt>{label}</dt>
            <dd>{formattedValue}</dd>
        </dl>
    );
};
